import * as React from 'react';

import {FormField} from 'shells/form/form-field';
import {TextField} from 'shells/textfield/textfield';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {getReduxFormError} from './helpers';

type BaseProps = {
    title?: string;
    placeholder: string;
    helperText?: string;
};

// Default variant
type ReduxFormProps = BaseProps &
    FieldProps & {
        variant: 'redux-form';
    };

type ControlledProps = BaseProps & {
    variant: 'controlled';
    name: string;
    value: string;
    onChange: (value: string) => void;
    error?: string | null | undefined;
};

type Props = ReduxFormProps | ControlledProps;

export function TinyIntroTextField(props: Props) {
    if (props.variant === 'controlled') {
        return (
            <FormField
                innerId={props.name}
                label={props.title}
                helperText={props.helperText}
                errorMessage={props.error}
            >
                <TextField
                    id={props.name}
                    // @ts-expect-error
                    name={props.name}
                    value={props.value}
                    onChange={props.onChange}
                    placeholder={props.placeholder}
                    hasError={Boolean(props.error)}
                    size='big'
                />
            </FormField>
        );
    }

    // Redux-form variant - spread extra props (disabled, autoFocus, etc.) to TextField
    const {title, placeholder, helperText, input, meta, ...textFieldProps} = props;
    const name = input.name;
    const error = getReduxFormError(meta);
    const hasError = Boolean(meta.error && meta.submitFailed);

    return (
        <FormField innerId={name} label={title} helperText={helperText} errorMessage={error}>
            <TextField
                {...input}
                {...textFieldProps}
                id={name}
                placeholder={placeholder}
                hasError={hasError}
                size='big'
            />
        </FormField>
    );
}
